<div id="chartContainer2" *ngIf="type !== 'horizontal'"
  [ngStyle]="{'display': isdata ? 'block' : 'none', 'visibility': isdata ? 'visible' : 'hidden'}">
</div>

<div class="timeline-chart-shell" *ngIf="type == 'horizontal'">
  <div class="timeline-chart-meta">
    <div class="timeline-state-legend">
      <span class="legend-pill legend-active"><i></i>Active</span>
      <span class="legend-pill legend-idle"><i></i>Idle</span>
      <span class="legend-pill legend-offline"><i></i>Offline</span>
      <ng-container *ngIf="conductTimelogs && conductTimelogs.length > 0">
        <ng-container *ngIf="distinctConductProjects.length > 0 && distinctConductProjects.length <= 3">
          <span class="legend-pill legend-conduct" *ngFor="let proj of distinctConductProjects">
            <i [style.background]="proj.color" style="border-radius: 3px;"></i>{{ proj.name }}
          </span>
        </ng-container>
        <span class="legend-pill legend-conduct" *ngIf="distinctConductProjects.length > 3">
          <span class="inline-flex items-center gap-0.5 mr-1">
            <i *ngFor="let proj of distinctConductProjects.slice(0, 4)" [style.background]="proj.color"
              style="width: 6px; height: 6px; border-radius: 2px; display: inline-block; margin: 0;"></i>
          </span>
          Conduct logged
        </span>
      </ng-container>
    </div>
    <span class="timeline-totals-heading">Row totals</span>
  </div>
  <div class="chartContainer-contain">
    <div id="chartContainer" #horizontalBarChartDiv
      [ngStyle]="{'display': isdata ? 'block' : 'none', 'visibility': isdata ? 'visible' : 'hidden'}"></div>
  </div>
</div>

<div class="empty_list z-depth-2"
  [ngStyle]="{'display': !isdata ? 'block' : 'none', 'visibility': !isdata ? 'visible' : 'hidden'}">
  <img src="assets/images/empty_list.png" alt="empty list image" />
</div>

<div *ngIf="type !== 'horizontal'" id="tooltipBarChart" #tooltipBarChart1 class="customTooltipDesign"
  style="margin-left: 0;margin-right: 0;">
  <div *ngIf="singleDayLog" class="work-summary bar-tooltip-summary">
    <div class="bar-tooltip-header">
      <p class="header_date">{{ tooltipDayLabel }} ({{ weekArr[index] }})</p>
    </div>
    <div class="bar-tooltip-metrics">
      <div class="bar-tooltip-metric">
        <p class="clock-text">Active Hours</p>
        <p class="clock-time">{{ singleDayLog.displayProductive }}</p>
      </div>
      <div class="bar-tooltip-metric">
        <p class="clock-text">Idle Hours</p>
        <p class="clock-time">{{ singleDayLog.displayIdle }}</p>
      </div>
      <div class="bar-tooltip-metric">
        <p class="clock-text">Offline Hours</p>
        <p class="clock-time">{{ singleDayLog.displayOffline }}</p>
      </div>
    </div>
  </div>
</div>

<!-- Horizontal floating bar chart - app usage tooltip -->
<div id="app_usage_tooltip_horizontal" class="app-usage-tooltip"
  *ngIf="type == 'horizontal' && selectedRowIndex !== null" #app_usage_tooltip_horizontal1>

  <div class="work-summary">
    <ng-container *ngIf="selectedRowIndex !== null">

    <div class="row timeline-user-row">
      <div class="col s12 l12 timeline-user-col tooltip-panel-header">
        <span class="user-name text-wrap" [routerLink]="['/user-details/', currentId]" *ngIf="currentId"
          style="cursor: pointer;">{{userName}}</span>
        <span class="header_date text-wrap" *ngIf="!currentId">{{userName}}</span>
        <button type="button" class="timeline-detail-close" (click)="closeTooltip()" aria-label="Close details">
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>

    <div class="tooltip-time-pair tooltip-meta-row" role="group" aria-label="Activity time span">
      <div class="tooltip-time-cell">
        <span class="clock-text">First Activity</span>
        <span class="clock-time">{{clockIn | date:"HH:mm"}}</span>
      </div>
      <div class="tooltip-time-cell">
        <span class="clock-text">Last Activity</span>
        <span class="clock-time">{{clockOut | date:"HH:mm"}}</span>
      </div>
    </div>

    <div class="tooltip-overview">
      <div class="overview-item overview-item-active">
        <span class="overview-label"><i class="overview-dot" aria-hidden="true"></i>Active</span>
        <span class="overview-value">{{ totalProductive }}</span>
      </div>
      <div class="overview-item overview-item-idle">
        <span class="overview-label"><i class="overview-dot" aria-hidden="true"></i>Idle</span>
        <span class="overview-value">{{ totalIdle }}</span>
      </div>
      <div class="overview-item overview-item-offline">
        <span class="overview-label"><i class="overview-dot" aria-hidden="true"></i>Offline</span>
        <span class="overview-value">{{ getOffLineCount(clockIn, clockOut, totalProductive, totalIdle) }}</span>
      </div>
    </div>

    <div class="tooltip-insights" *ngIf="getActivityMix() as mix">
      <div class="insight-card insight-card-row">
        <span class="insight-label">Tracked window</span>
        <span class="insight-value tabular-nums">{{ getTrackedWindowDuration() }}</span>
      </div>
      <div class="insight-card insight-card-row">
        <span class="insight-label">Activity mix</span>
        <span class="insight-value insight-mix-line">
          <span class="mix-seg mix-active">A {{ mix.active }}%</span>
          <span class="mix-sep" aria-hidden="true">·</span>
          <span class="mix-seg mix-idle">I {{ mix.idle }}%</span>
          <span class="mix-sep" aria-hidden="true">·</span>
          <span class="mix-seg mix-off">O {{ mix.offline }}%</span>
        </span>
      </div>
      <div class="insight-card insight-card-row insight-card-top-app" *ngIf="getTopApplicationInsight() as topApp">
        <span class="insight-label">Top application</span>
        <span class="insight-value insight-top-app">
          <span class="insight-app-name text-wrap">{{ topApp.appName || 'Unknown application' }}</span>
          <span class="insight-app-usage tabular-nums">{{ topApp.totalUsage }}</span>
        </span>
      </div>
    </div>

    <!-- divider if required -->
    <div *ngIf="workingHoursStart && workingHoursEnd; else noShift">
      <div class="row shift-summary">
        <div class="col s12 l12">
          <table class="summary-table">
            <thead>
              <tr>
                <th class="summary-th-first"></th>
                <th>Active</th>
                <th>Idle</th>
                <th>Offline</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="summary-td-first">Shift ({{workingHoursStart }} - {{workingHoursEnd }})</td>
                <td>{{ totalProductiveInside }}</td>
                <td>{{ totalIdleInside }}</td>
                <td>{{ offlineInside }}</td>
              </tr>
              <tr>
                <td class="summary-td-first">Outside shift</td>
                <td>{{ totalProductiveOutside }}</td>
                <td>{{ totalIdleOutside }}</td>
                <td>{{ offlineOutside }}</td>
              </tr>
              <tr>
                <td class="summary-td-first">Total ({{ clockIn | date:"HH:mm" }} – {{ clockOut | date:"HH:mm" }})</td>
                <td>{{ totalProductive }}</td>
                <td>{{ totalIdle }}</td>
                <td>{{ getOffLineCount(clockIn, clockOut, totalProductive, totalIdle) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div *ngIf="inOutInside && inOutInside.length; else noInsideData">

        <div class="row app-usage-section">
          <div class="col s12 l12 section-title">Inside working hours</div>
          <div id="app_usage_tooltip_list_inside" class="app-usage-grid-wrap">
            <div class="app-usage-grid" role="table" aria-label="Application usage inside shift">
              <div class="app-usage-grid-head" role="row">
                <span role="columnheader">Application</span>
                <span role="columnheader">Usage</span>
              </div>
              <div class="app-usage-grid-row" *ngFor="let item of inOutInside" role="row">
                <span class="app-name text-wrap" [title]="item.appName || 'Unknown application'" role="cell">
                  {{(item.appName || 'Unknown application') | slice:0:28}}
                </span>
                <span class="app-duration tabular-nums" role="cell">{{item.totalUsage}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <ng-template #noInsideData>
        <div class="row app-usage-section">
          <div class="col s12 l12 section-title">Inside working hours</div>
          <div class="no-work-message">
            Employee was not working
          </div>
        </div>
      </ng-template>

      <div *ngIf="inOutOutside && inOutOutside.length; else noOutsideData">
        <div class="row app-usage-section">
          <div class="col s12 l12 section-title">Outside working hours</div>
          <div id="app_usage_tooltip_list_outside" class="app-usage-grid-wrap">
            <div class="app-usage-grid" role="table" aria-label="Application usage outside shift">
              <div class="app-usage-grid-head" role="row">
                <span role="columnheader">Application</span>
                <span role="columnheader">Usage</span>
              </div>
              <div class="app-usage-grid-row" *ngFor="let item of inOutOutside" role="row">
                <span class="app-name text-wrap" [title]="item.appName || 'Unknown application'" role="cell">
                  {{(item.appName || 'Unknown application') | slice:0:28}}
                </span>
                <span class="app-duration tabular-nums" role="cell">{{item.totalUsage}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noOutsideData>
        <div class="row app-usage-section">
          <div class="col s12 l12 section-title">Outside working hours</div>
          <div class="no-work-message">
            Employee was not working
          </div>
        </div>
      </ng-template>
    </div>
    </ng-container>
  </div>

  <ng-template #noShift>
    <div class="row app-usage-section" *ngIf="inOut && inOut.length">
      <div id="app_usage_tooltip_list" class="app-usage-grid-wrap">
        <div class="app-usage-grid" role="table" aria-label="Application usage">
          <div class="app-usage-grid-head" role="row">
            <span role="columnheader">Application</span>
            <span role="columnheader">Usage</span>
          </div>
          <div class="app-usage-grid-row" *ngFor="let item of inOut" role="row">
            <span class="app-name text-wrap" [title]="item.appName || 'Unknown application'" role="cell">
              {{(item.appName || 'Unknown application') | slice:0:28}}
            </span>
            <span class="app-duration tabular-nums" role="cell">{{item.totalUsage}}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

</div>

<ng-template #noInOut>
  <div style="margin: 5px 0px;">
    Employee was not working
  </div>
</ng-template>

<!-- Conduct Task Time Log White-Theme Tooltip -->
<div *ngIf="hoveredConductTask" #conductTooltipRef class="conduct-task-white-tooltip" [style.left.px]="conductTooltipX"
  [style.top.px]="conductTooltipY" (click)="$event.stopPropagation()">

  <div class="conduct-tooltip-card">
    <!-- Header: Task Unique ID Badge + Project Name -->
    <div class="conduct-tooltip-header">
      <span class="conduct-tooltip-project truncate">
        {{ hoveredConductTask.project_name || 'General Project' }}
      </span>
    </div>

    <!-- Task Title -->
    <div class="conduct-tooltip-title">
      {{ hoveredConductTask.task_title || 'General Task' }}
    </div>

    <!-- Section 1: Conduct Task Time Logs -->
    <div class="conduct-tooltip-section">
      <div class="conduct-tooltip-section-title">
        Logged on Conduct
      </div>
      <div class="conduct-tooltip-table-row">
        <span class="conduct-tooltip-time-range">{{ hoveredConductTaskTimeRange }}</span>
        <span class="conduct-tooltip-logged-time">{{ hoveredConductTaskDuration }} logged</span>
      </div>
    </div>

    <!-- Section 2: SuperSee Time Tracked -->
    <div class="conduct-tooltip-section">
      <div class="conduct-tooltip-section-title">
        Tracked by SuperSee
      </div>
      <div class="conduct-tooltip-table-row">
        <span class="conduct-tooltip-time-range">{{ hoveredSuperSeeTimeRange }}</span>
        <span class="conduct-tooltip-logged-time">{{ hoveredConductActiveInWindow }} active</span>
      </div>
      <div class="conduct-tooltip-table-row mt-1" *ngIf="hoveredConductIdleSecs > 0">
        <span class="conduct-tooltip-time-range text-slate-500">Idle</span>
        <span class="conduct-tooltip-logged-time text-slate-600 font-medium">{{ hoveredConductIdleText }} idle</span>
      </div>
      <div class="conduct-tooltip-table-row mt-1" *ngIf="hoveredConductOfflineSecs > 0">
        <span class="conduct-tooltip-time-range text-slate-500">Offline</span>
        <span class="conduct-tooltip-logged-time text-slate-500 font-medium">{{ hoveredConductOfflineText }} offline</span>
      </div>
    </div>

    <!-- Section 3: Time Difference Note (shown only when difference exists) -->
    <div class="conduct-tooltip-diff-note" *ngIf="hoveredConductTimeDifferenceSecs > 0">
      <span>Time Difference (SuperSee & Conduct): {{ hoveredConductTimeDifference }}</span>
    </div>

    <!-- Divider -->
    <div class="conduct-tooltip-divider"></div>

    <!-- Bottom Right Action: Work Replay -->
    <div class="conduct-tooltip-footer">
      <a class="conduct-tooltip-replay-link" (click)="navigateToWorkReplay(hoveredConductTask)"
        matTooltip="See insights on work replay page">
        <span>Work Replay</span>
        <svg class="conduct-tooltip-arrow-icon" viewBox="0 0 16 16" fill="currentColor">
          <path fill-rule="evenodd"
            d="M1 8a.75.75 0 0 1 .75-.75h10.69L8.72 3.53a.75.75 0 0 1 1.06-1.06l5 5a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06-1.06l3.72-3.72H1.75A.75.75 0 0 1 1 8Z"
            clip-rule="evenodd" />
        </svg>
      </a>
    </div>
  </div>
</div>